import ProductContainer from "./product.container";

export default ProductContainer;
